import React from 'react';
import {
  Box,
  VStack,
  Text,
  Heading,
  Link,
  useColorModeValue,
} from '@chakra-ui/react';

function DisplayProductContinue() {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      borderColor={borderColor}
      bg={bgColor}
      p={8}
    >
      <VStack spacing={6} align="stretch">
        <Heading size="lg" textAlign="center">
          Continue in calibrite PROFILER
        </Heading>
        
        <Text fontSize="lg">
          To continue, please connect your Calibrite device to the software. This is required to register your device and unlock full functionality.
        </Text>
        
        <Text fontSize="lg">
          Make sure your device is powered on and properly connected via USB.
        </Text>
        
        <Text fontSize="lg">
          Download calibrite PROFILE{' '}
          <Link color="blue.500" href="#" textDecoration="underline">
            here
          </Link>
          .
        </Text>
      </VStack>
    </Box>
  );
}

export default DisplayProductContinue; 